import { API_URL } from "@/http/apiBase";
import axios from "axios";

/**
 * KeyCloak API functions for authorisation user info and refresh tokens
 */

/**
 * Login and get token
 * @param {string} email
 * @param {string} code
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function logIn(email, code) {
  return axios.post(
    `${API_URL}/auth/login`,
    {
      email,
      code,
    },
    {
      withCredentials: true,
    }
  );
}
/**
 * send otp
 * @param {string} email
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function sendCode(email) {
  return axios.post(
    `${API_URL}/auth/otp`,
    {
      email,
    },
    {
      withCredentials: true,
    }
  );
}

/**
 * Logout user
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function logOut(token) {
  // POST, не GET (NANFin-XXX, P1): GET-логаут был CSRF-вектором — refresh-cookie
  // уходила и на кросс-сайтовые запросы, поэтому любой сторонний сайт мог разлогинить
  // пользователя простым <img src=".../api/auth/logout">. Бэк держит deprecated
  // GET-алиас на переходный период и удалит его после релиза этого фронта.
  //
  // Сигнатура axios.post — (url, data, config). Конфиг идёт ТРЕТЬИМ аргументом;
  // у axios.get он второй. Именно на этом раньше горело: конфиг клали третьим
  // аргументом в get, он молча игнорировался, запрос уходил без Bearer и без
  // withCredentials — и бэк не мог погасить серверную сессию.
  return axios.post(`${API_URL}/auth/logout`, null, {
    withCredentials: true,
    headers: {
      Authorization: "Bearer " + token,
    },
  });
}

/**
 * Get new token via refresh token (httpOnly-cookie).
 * POST, не GET (NANFin-XXX): GET браузер/прокси могут молча ретраить и кэшировать;
 * refresh — операция выдачи токена, семантически не «чтение». Бэк держит
 * deprecated GET-алиас на переходный период.
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function refreshToken(token) {
  return axios.post(`${API_URL}/auth/refresh`, null, {
    headers: {
      Authorization: "Bearer " + token,
    },
    withCredentials: true,
  });
}
